export const ModuleContext = 'context';
export const ModuleTourGuide = 'tourGuide';
export const ModuleManual = 'manual';
export const ModuleDocumentSigner = 'documentSigner';
export const ModuleNotification = 'notification';
export const ModuleOption = 'option';
export const ModuleEmployee = 'employee';
export const ModuleEmployeeType = 'employeeType';
export const ModulePayrollItem = 'payrollItem';
export const ModuleLayout = 'layout';
export const ModuleOrganizationUnit = 'organizationUnit';
export const ModuleAsset = 'asset';
export const ModuleInventoryItem = 'inventoryItem';
export const ModuleAccount = 'account';
export const ModuleBuPlanWithDraw = 'buPlanWithDraw';
export const ModuleBUTransfer = 'bUTransfer';
export const ModuleAccountingObject = 'accountingObject';
export const ModuleDepartment = 'department';
export const ModuleCurrency = 'currency';
export const ModuleBaWithdraw = 'baWithdraw';
export const ModuleInventoryCategory = 'inventoryCategory';
export const ModuleStock = 'stock';
export const ModuleBuPlanReceipt = 'buPlanReceipt';
export const ModuleBudgetChapter = 'budgetChapter';
export const ModuleStatistic = 'statistic';
export const ModuleTypeOfFundObject = 'typeOfFund';
export const ModuleBankInfoCategory = 'bankInfoCategory';
export const ModuleBudgetGroupItem = 'budgetGroupItem';
export const ModuleBudgetSourceProperty = 'budgetSourceProperty';
export const ModuleCAReceipt = 'cAReceipt';
export const ModuleCAReceiptSale = 'cAReceiptSale';
export const ModuleBudgetSource = 'budgetSource';
export const ModuleBUVoucherList = 'bUVoucherList';
export const ModuleBudgetItem = 'budgetItem';
export const ModuleBankInfo = 'bankInfo';
export const ModuleBUPlanAdjustment = 'bUPlanAdjustment';
export const ModuleBudgetKindItem = 'budgetKindItem';
export const ModuleSUTransfer = 'sUTransfer';
export const ModuleInInwardOutward = 'inInwardOutward';
export const ModuleSUIncrementDecrement = 'sUIncrementDecrement';
export const ModuleBUPlanWDAdjustment = 'bUPlanWDAdjustment';
export const ModulePUInvoice = 'pUInvoice';
export const ModuleINTransfer = 'iNTransfer';
export const ModuleINAdjustment = 'iNAdjustment';
export const ModulePurchasePurpose = 'purchasePurpose';
export const ModuleCAPayment = 'cAPayment';
export const ModuleCAPaymentDetail = 'cAPaymentDetail';
export const ModuleCAPaymentDetailTax = 'cAPaymentDetail';
export const ModuleBudgetFees = 'budgetFees';
export const ModuleAccountTransfer = 'accountTransfer';
export const ModuleBADeposit = 'bADeposit';
export const ModuleAutoBusiness = 'autoBusiness';
export const ModuleSAInvoice = 'sAInvoice';
export const ModuleBABankTransfer = 'bABankTransfer';
export const ModuleBUBudgetReserve = 'bUBudgetReserve';
export const ModuleGLVoucher = 'gLVoucher';
export const ModuleGLVoucherList = 'gLVoucherList';
export const ModuleActivity = 'activity';
export const ModuleCustomerVendor = 'customerVendor';
export const ModuleAccountingObjectCategory = 'accountingObjectCategory';
export const ModuleVoucherType = 'voucherType';
export const ModuleSAReturn = 'sAReturn';
export const ModuleInvoiceFormNumber = 'invoiceFormNumber';
export const ModuleBUCommitmentRequest = 'bUCommitmentRequest';
export const ModuleBUCommitmentAdjustment = 'bUCommitmentAdjustment';
export const ModuleBUOpeningCommitment = 'bUOpeningCommitment';
export const ModuleProject = 'project';
export const ModuleTargetProgram = 'targetProgram';
export const ModuleProjectBudgetDetail = 'projectBudgetDetail';
export const ModuleContract = 'contract';
export const ModuleTask = 'task';
export const ModuleTopic = 'topic';
export const ModuleWorkItem = 'workItem';
export const ModuleQltsVoucher = 'qltsVoucher';
export const ModuleBATransfer = 'bATransfer';
export const ModuleBUPlanImport = 'bUPlanImport';
export const ModuleCRERepList = 'cRERepList';
export const ModuleAccountParallelRule = 'accountParallelRule';
export const ModuleDefaultAccount = 'defaultAccount';

export const ModuleCRERepExportList = 'cRERepExportList';
export const ModuleCRERepExportTaxList = 'cRERepExportTaxList';
export const ModuleOpeningSupplyEntry = 'openingSupplyEntry';
export const ModuleFundStructure = 'fundStructure';
export const ModuleCRERepSettlement = 'cRERepSettlement';
export const ModuleDbOption = 'dbOption';
export const ModuleOpeningAccountEntry = 'openingAccountEntry';
export const ModuleSalaryScale = 'salaryScale';
export const ModulePAOption = 'pAOption';
export const ModulePayrollItemColumn = 'payrollItemColumn';
export const ModuleOpeningAccountEntryStatistic = 'openingAccountEntryStatistic';

export const ModuleBudgetProvide = 'budgetProvide';
export const ModuleAccountParallelRuleDetail = 'accountParallelRuleDetail';
export const ModuleBudgetSourceTranfer = 'budgetSourceTranfer';
export const ModuleAccountingObjectChangeRate = 'accountingObjectChangeRate';

export const ModuleToolType = 'toolType';
export const ModuleAccountChangeTranfer = 'accountChangeTranfer';
export const ModuleBudgetKindItemTranfer = 'budgetKindItemTranfer';
export const ModuleStateBank = 'stateBank';
export const ModuleProjectTranfer = 'projectTranfer';

export const ModuleSysAccountParallelVoucherListRule = 'sysAccountParallelVoucherListRule';
export const ModuleSysAccountParallelVoucherListRuleDetail = 'sysAccountParallelVoucherListRuleDetail';
export const ModuleUserSetting = "userSetting";
export const ModuleColumnSetting = "columnSetting";
export const ModuleSort = "sort";

export const ModuleDashboard = 'dashboard';
export const ModuleExport = 'export';
export const ModuleImport = 'import';
export const ModuleTourGuideUpdate = 'tourGuideUpdate';
export const ModuleSurveyCustomer = 'surveyCustomer';

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleContext,
  ModuleOption,
  ModuleEmployee,
  ModuleEmployeeType,
  ModulePayrollItem,
  ModuleLayout,
  ModuleOrganizationUnit,
  ModuleAsset,
  ModuleInventoryItem,
  ModuleAccount,
  ModuleBuPlanWithDraw,
  ModuleBUTransfer,
  ModuleAccountingObject,
  ModuleDepartment,
  ModuleCurrency,
  ModuleBaWithdraw,
  ModuleInventoryCategory,
  ModuleStock,
  ModuleBuPlanReceipt,
  ModuleBudgetChapter,
  ModuleStatistic,
  ModuleTypeOfFundObject,
  ModuleBankInfoCategory,
  ModuleBudgetGroupItem,
  ModuleBudgetSourceProperty,
  ModuleCAReceipt,
  ModuleCAReceiptSale,
  ModuleBudgetSource,
  ModuleBankInfo,
  ModuleBUVoucherList,
  ModuleBudgetItem,
  ModuleBUPlanAdjustment,
  ModuleBudgetKindItem,
  ModuleSUTransfer,
  ModuleInInwardOutward,
  ModuleSUIncrementDecrement,
  ModuleBUPlanWDAdjustment,
  ModulePUInvoice,
  ModuleINTransfer,
  ModuleINAdjustment,
  ModulePurchasePurpose,
  ModuleCAPayment,
  ModuleCAPaymentDetail,
  ModuleCAPaymentDetailTax,
  ModuleBudgetFees,
  ModuleAccountTransfer,
  ModuleBADeposit,
  ModuleAutoBusiness,
  ModuleSAInvoice,
  ModuleBABankTransfer,
  ModuleBUBudgetReserve,
  ModuleGLVoucher,
  ModuleGLVoucherList,
  ModuleActivity,
  ModuleCustomerVendor,
  ModuleAccountingObjectCategory,
  ModuleVoucherType,
  ModuleSAReturn,
  ModuleInvoiceFormNumber,
  ModuleBUCommitmentRequest,
  ModuleBUCommitmentAdjustment,
  ModuleBUOpeningCommitment,
  ModuleProject,
  ModuleTargetProgram,
  ModuleProjectBudgetDetail,
  ModuleContract,
  ModuleTask,
  ModuleTopic,
  ModuleWorkItem,
  ModuleQltsVoucher,
  ModuleBATransfer,
  ModuleBUPlanImport,
  ModuleCRERepList,
  ModuleOpeningSupplyEntry,
  ModuleFundStructure,
  ModuleAccountParallelRule,
  ModuleCRERepExportList,
  ModuleDefaultAccount,
  ModuleCRERepSettlement,
  ModuleDbOption,
  ModuleCRERepExportTaxList,
  ModuleOpeningAccountEntry,
  ModuleSalaryScale,
  ModulePAOption,
  ModulePayrollItemColumn,
  ModuleOpeningAccountEntryStatistic,
  ModuleBudgetProvide,
  ModuleAccountParallelRuleDetail,
  ModuleBudgetSourceTranfer,
  ModuleToolType,
  ModuleBudgetProvide,
  ModuleAccountingObjectChangeRate,
  ModuleAccountChangeTranfer,
  ModuleBudgetKindItemTranfer,
  ModuleStateBank,
  ModuleProjectTranfer,
  ModuleSysAccountParallelVoucherListRule,
  ModuleSysAccountParallelVoucherListRuleDetail,
  ModuleUserSetting,
  ModuleColumnSetting,
  ModuleSort,
  ModuleExport,
  ModuleImport,
  ModuleTourGuideUpdate,
  ModuleSurveyCustomer
];
